import { ENGLISH_TEST_TYPE_VAL_LABEL_MAP, QUALIFICATION_VAL_LABEL_MAP } from 'data';
import { SummaryRow } from '../../../Summary/SummaryRow';
import { Q } from '../../../../store/student/types';
import { IRisk } from '../../../../types';
import { useTranslation } from "react-i18next";

interface Props {
  showRisks: boolean;
  hasEnglishTest: string;
  englishTestType?: string;
  englishTestTypeOther?: string;
  englishTestNotReqdReason?: string;
  englishTestNotReqdReasonOther?: string;
  qualification?: string;
  qualificationOther?: string;
  riskList?: IRisk['personalInfoRisk']['englishTest'];
}

const PREVIOUS_TEST_VALUE = 'Previous test';

const READABLE_ADDITIONAL_TEST_VALUES_MAP: { [key: string]: string } = {
  'Previous visa application': 'Met in a previous visa application',
  'English speaking country': 'Majority English speaking country national',
  'Previous test': 'Based on previous qualification',
  'US study abroad': `Part of US study abroad programme`,
  'Gifted student': `Gifted student`,
  Other: `Other/Don’t know`,
};

function EnglishTestPI({
  showRisks,
  hasEnglishTest,
  englishTestType,
  englishTestTypeOther,
  englishTestNotReqdReason,
  englishTestNotReqdReasonOther,
  qualification,
  qualificationOther,
  riskList = [],
}: Props) {
    const { t } = useTranslation('forms.visa');
  return (
    <>
      <SummaryRow
        key="hasEnglishTest"
        label={t('forms.visa:hasEnglishTest')}
        fullLabel="Were you required to submit an English test as part of your application?"
        value={hasEnglishTest}
        isRisk={showRisks && riskList.includes(Q.HAS_ENGLISH_TEST)}
      />

      {hasEnglishTest === 'Yes' && englishTestType && (
        <SummaryRow
          key="englishTestType"
          label={t('forms.visa:type')}
          fullLabel="What type of English test?"
          value={ENGLISH_TEST_TYPE_VAL_LABEL_MAP[englishTestType]}
          isRisk={showRisks && riskList.includes(Q.ENGLISH_TEST_TYPE)}
        />
      )}
      {hasEnglishTest === 'Yes' && englishTestType === 'Other' && englishTestTypeOther && (
        <SummaryRow
          key="englishTestTypeOther"
          label={t('forms.visa:otherTypeName')}
          fullLabel="What is the name of the English test you completed?"
          value={englishTestTypeOther}
          isRisk={showRisks && riskList.includes(Q.ENGLISH_TEST_TYPE_OTHER)}
        />
      )}
      {hasEnglishTest === 'No' && englishTestNotReqdReason && (
        <SummaryRow
          key="englishTestNotReqdReason"
          label={t('forms.visa:englishTestNotRequiredReason')}
          fullLabel="How did you meet the English language requirement?"
          value={READABLE_ADDITIONAL_TEST_VALUES_MAP[englishTestNotReqdReason]}
          isRisk={showRisks && riskList.includes(Q.ENGLISH_TEST_NOT_REQD_REASON)}
        />
      )}
      {hasEnglishTest === 'No' && englishTestNotReqdReason === `Other` && englishTestNotReqdReasonOther && (
        <SummaryRow
          key="englishTestNotReqdReasonOther"
          label={t('forms.visa:pleaseExplain')}
          fullLabel="Please explain"
          value={englishTestNotReqdReasonOther}
          isRisk={showRisks && riskList.includes(Q.ENGLISH_TEST_NOT_REQD_REASON_OTHER)}
        />
      )}
      {hasEnglishTest === 'No' && englishTestNotReqdReason === PREVIOUS_TEST_VALUE && qualification && (
        <SummaryRow
          key="qualification"
          label={t('forms.visa:qualification')}
          fullLabel="Which qualification?"
          value={QUALIFICATION_VAL_LABEL_MAP[qualification]}
          isRisk={showRisks && riskList.includes(Q.QUALIFICATION)}
        />
      )}
      {hasEnglishTest === 'No' &&
        englishTestNotReqdReason === PREVIOUS_TEST_VALUE &&
        qualification === 'Other' &&
        qualificationOther && (
          <SummaryRow
            key="qualificationOther"
            label={t('forms.visa:otherQualificationName')}
            fullLabel="What is the name of the qualification?"
            value={qualificationOther}
            isRisk={showRisks && riskList.includes(Q.QUALIFICATION)}
          />
        )}
    </>
  );
}

export default EnglishTestPI;
